var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6V12V6ZM10.5 12L7.33333 9L10.5 12ZM10.5 12L13.6667 9L10.5 12ZM1 13V3C1 2.46957 1.22242 1.96086 1.61833 1.58579C2.01424 1.21071 2.55121 1 3.11111 1H9.44444L11.5556 3H17.8889C18.4488 3 18.9858 3.21071 19.3817 3.58579C19.7776 3.96086 20 4.46957 20 5V13C20 13.5304 19.7776 14.0391 19.3817 14.4142C18.9858 14.7893 18.4488 15 17.8889 15H3.11111C2.55121 15 2.01424 14.7893 1.61833 14.4142C1.22242 14.0391 1 13.5304 1 13Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/pdf_download.04f64bf8037365daad358a047201afe7.svg";
export { ForwardRef as ReactComponent };